/**
 * Filegroup Manager Feature Module
 *
 * Registers the filegroup-manager workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the filegroup-manager workspace component
registerWorkspaceComponent(
  'filegroup-manager',
  lazyWorkspaceTab(() => import('./components/FilegroupManagerTab').then((m) => ({ default: m.FilegroupManagerTab }))),
);

// Re-export components
